import { render, staticRenderFns } from "./AccessWalletDerivationPath.vue?vue&type=template&id=2f6e054a&scoped=true"
import script from "./AccessWalletDerivationPath.vue?vue&type=script&lang=js"
export * from "./AccessWalletDerivationPath.vue?vue&type=script&lang=js"
import style0 from "./AccessWalletDerivationPath.vue?vue&type=style&index=0&id=2f6e054a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e054a",
  null
  
)

export default component.exports